import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: "[appOnlyNumber]",
})
export class OnlyNumberDirective {
  @Input("appOnlyNumber") isOnlyNumber: boolean;

  private regex: RegExp = new RegExp(/^[0-9]+$/g);

  private specialKeys: Array<string> = ["Backspace", "Tab", "End", "Home", "ArrowLeft", "ArrowRight", "Delete"];

  constructor(private el: ElementRef) {}

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex) && this.isOnlyNumber) {
      event.preventDefault();
    }
  }
  
  @HostListener("paste", ["$event"])
  onPaste(event: ClipboardEvent) {
    if (!this.isOnlyNumber) {
      return;
    }
    event.preventDefault();
    const input = this.el.nativeElement;
    const pastedText = event.clipboardData?.getData('text') ?? '';
    // Keep numbers only from the beginning
    let numericText = pastedText.match(/^\d+/)?.[0] ?? '';
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    // Respect maxlength
    const maxLength = input.maxLength;
    if (maxLength > 0) {
      const currentLengthAfterReplacement = input.value.length - (end - start);
      const availableLength = maxLength - currentLengthAfterReplacement;
      if (availableLength <= 0) {
        numericText = '';
      } else {
        numericText = numericText.substring(0, availableLength);
      }
    }
    input.setRangeText(numericText, start, end, 'end');
    // Update Angular Reactive Form
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
